import classNames from 'classnames'

import { Link } from '../../Link'

import * as styles from './NotificationLink.module.css'

function NotificationLink({
  Component = Link,
  className,
  title,
  ...restProps
}) {
  const linkClassName = classNames(styles.link, className)

  return (
    <div className={linkClassName}>
      <Component {...restProps}>{title}</Component>
    </div>
  )
}

export default NotificationLink
